import {
  PENDING_PAYMENTS_DETAILS_START,
  PENDING_PAYMENTS_DETAILS_SUCCESS,
  PENDING_PAYMENTS_DETAILS_ERROR,
  COMPLETED_PAYMENTS_DETAILS_START,
  COMPLETED_PAYMENTS_DETAILS_SUCCESS,
  COMPLETED_PAYMENTS_DETAILS_ERROR,
  CANCEL_CHARGE_PAYMENTS_DETAILS_START,
  CANCEL_CHARGE_PAYMENTS_DETAILS_SUCCESS,
  CANCEL_CHARGE_PAYMENTS_DETAILS_ERROR,
  PENALTY_PAYMENTS_DETAILS_START,
  PENALTY_PAYMENTS_DETAILS_SUCCESS,
  PENALTY_PAYMENTS_DETAILS_ERROR,
  RESENT_PAYMENT_START,
  RESENT_PAYMENT_SUCCESS,
  RESENT_PAYMENT_ERROR,
  CLEAR_PREVIOUS_REDUCER,
} from "Constant";

const initialState = {
  loading: false,
  paymentsDetailsData: {},
  completePaymentsDetailsData: {},
  cancelPaymentsDetailsData: {},
  penaltyPaymentsDetailsData: {},
  resentPayment: {},
};
export default function PaymentDetailsReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case PENALTY_PAYMENTS_DETAILS_START:
      return {
        ...state,
        loading: true,
      };
    case PENALTY_PAYMENTS_DETAILS_SUCCESS:
      return {
        ...state,
        penaltyPaymentsDetailsData: action.payload,
        loading: false,
      };
    case PENALTY_PAYMENTS_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case RESENT_PAYMENT_START:
      return {
        ...state,
        loading: true,
      };
    case RESENT_PAYMENT_SUCCESS:
      return {
        ...state,
        resentPayment: action.payload,
        loading: false,
      };
    case RESENT_PAYMENT_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case CANCEL_CHARGE_PAYMENTS_DETAILS_START:
      return {
        ...state,
        cancelPaymentsDetailsData: {},
        loading: true,
      };
    case CANCEL_CHARGE_PAYMENTS_DETAILS_SUCCESS:
      return {
        ...state,
        cancelPaymentsDetailsData: action.payload,
        loading: false,
      };
    case CANCEL_CHARGE_PAYMENTS_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };

    case COMPLETED_PAYMENTS_DETAILS_START:
      return {
        ...state,
        loading: true,
      };
    case COMPLETED_PAYMENTS_DETAILS_SUCCESS:
      return {
        ...state,
        completePaymentsDetailsData: action.payload,
        loading: false,
      };
    case COMPLETED_PAYMENTS_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };

    case PENDING_PAYMENTS_DETAILS_START:
      return {
        ...state,
        loading: true,
      };
    case PENDING_PAYMENTS_DETAILS_SUCCESS:
      return {
        ...state,
        paymentsDetailsData: action.payload,
        loading: false,
      };
    case PENDING_PAYMENTS_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };

    case CLEAR_PREVIOUS_REDUCER:
      return {
        ...state,
        paymentsDetailsData: {},
        completePaymentsDetailsData: {},
        cancelPaymentsDetailsData: {},
        penaltyPaymentsDetailsData: {},
      };

    default:
      return state;
  }
}
